/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
        defauleSearchSchema:{
            defaultFilter:[
                {"label":"趋势分析","key":"trend","size":10,
                  "buckets":[
                      {"key":'applicationYear',"label": '申请趋势','default': 'lineChart'},
                      {"key":'publicationYear',"label": '公开趋势','default': 'lineChart'},
                    ]
                },
                {"label":"技术分析","key":"technology","size":10,
                  "buckets":[
                    {"key":'ipc3',"label": '技术构成','default': 'barChart'},
                    {"key":'ipc3-applicationYear',"label": '技术申请趋势','default': 'lineChart'},
                    {"key":'ipc3-publicationYear',"label": '技术公开趋势','default': 'lineChart'},
                    {"key":'ipc3-countryCode',"label": '技术全球分布','default': 'lineChart'},
                    {"key":'ipc3-province',"label": '技术中国省市分布','default': 'barChart'},
                    {"key":'ipc3-city',"label": '技术中国地市分布','default': 'barChart'},
                    {"key":'mainIpc3',"label": '主技术构成','default': 'barChart'},
                    {"key":'mainIpc3-applicationYear',"label": '主技术申请趋势','default': 'lineChart'},
                    {"key":'mainIpc3-publicationYear',"label": '主技术公开趋势','default': 'lineChart'},
                    {"key":'mainIpc3-countryCode',"label": '主技术全球分布','default': 'barChart'},
                    {"key":'mainIpc3-province',"label": '主技术中国省市分布','default': 'barChart'},
                    {"key":'mainIpc3-city',"label": '主技术中国地市分布','default': 'barChart'},
                    {"key":'level',"label": '专业价值构成','default': 'pieChart'},
                  ]
                 },
                {"label":"申请人分析","key":"applicant","size":10,
                  "buckets":[
                    {"key":'applicant',"label": '申请人排名','default': 'barChart'},
                    {"key":'applicantType',"label": '申请人类型构成','default': 'barChart'},
                    {"key":'applicant-applicationYear',"label": '申请人申请趋势','default': 'lineChart'},
                    {"key":'applicant-publicationYear',"label": '申请人公开趋势','default': 'lineChart'},
                    {"key":'applicant-ipc3',"label": '申请人技术构成','default': 'barChart'},
                    {"key":'applicant-level',"label": '申请人专利价值','default': 'barChart'},
                  ] 
                },
                {"label":"发明人分析","key":"inventor","size":10,
                  "buckets":[
                    {"key":'inventor',"label": '发明人排名','default': 'barChart'},
                    {"key":'inventor-ipc3',"label": '发明人技术构成','default': 'barChart'}
                  ] 
                },
                {"label":"地域分析","key":"country","size":10,
                  "buckets":[
                    {"key":'countryCode',"label": '全球地域排名','default': 'barChart'},
                    {"key":'countryCode-applicationYear',"label": '全球申请趋势','default': 'lineChart'},
                    {"key":'countryCode-publicationYear',"label": '全球公开趋势','default': 'lineChart'},
                    {"key":'countryCode-ipc3',"label": '全球技术构成','default': 'barChart'},
                    {"key":'type',"label": '中国专利类型','default': 'pieChart'},
                    {"key":'country',"label": '中国专利申请人国别','default': 'barChart'},
                    {"key":'province',"label": '中国省市排名','default': 'barChart'},
                    {"key":'province-applicationYear',"label": '中国省市申请趋势','default': 'lineChart'},
                    {"key":'province-publicationYear',"label": '中国省市公开趋势','default': 'lineChart'},
                  ] 
                },
                {"label":"法律及运营分析","key":"legal","size":10,
                  "buckets":[
                    {"key":'currentStatus',"label": '中国专利当前法律状态','default': 'barChart'},
                    {"key":'legalStatus',"label": '中国专利有效性','default': 'barChart'},
                    {"key":'majorEvents.exeDate_2',"label": '转让趋势','default': 'lineChart'},
                    {"key":'majorEvents.pre_2',"label": '转让人排名','default': 'barChart'},
                    {"key":'majorEvents.after_2',"label": '受让人排名','default': 'barChart'},
                    {"key":'majorEvents.ipc3_2',"label": '转让技术构成','default': 'barChart'},
                    {"key":'majorEvents.exeDate_3',"label": '许可趋势','default': 'lineChart'},
                    {"key":'majorEvents.pre_3',"label": '许可人排名','default': 'barChart'},
                    {"key":'majorEvents.after_3',"label": '被许可人排名','default': 'barChart'},
                    {"key":'majorEvents.ipc3_3',"label": '许可技术构成','default': 'barChart'},
                    {"key":'majorEvents.exeDate_4',"label": '质押趋势','default': 'lineChart'},
                    {"key":'majorEvents.pre_4',"label": '出质人排名','default': 'barChart'},
                    {"key":'majorEvents.after_4',"label": '质权人排名','default': 'barChart'},
                    {"key":'majorEvents.ipc3_4',"label": '质押技术构成','default': 'barChart'},
                    {"key":'judgment.accuser',"label": '诉讼当事人排名','default': 'barChart'},
                    {"key":'reexamination.wxPerson',"label": '无效请求人排名','default': 'barChart'},
                    {"key":'reexamination.fsPerson',"label": '复审请求人排名','default': 'barChart'},
                  ] 
                },
                {"label":"专利代理分析","key":"agency","size":10,
                    "buckets":[
                        {"key":'agency',"label": '代理机构排名','default': 'barChart'},
                        {"key":'agent',"label": '代理人排名','default': 'barChart'},
                        {"key":'agency-ipc3',"label": '代理机构技术构成','default': 'barChart'},
                        {"key":'agent-ipc3',"label": '代理人技术构成','default': 'barChart'},
                    ]
                },
                // {"label":"自定义分析","key":"other","size":10,
                //     "buckets":[]
                // }
            ],
        },
         // 保存的搜索方案
        savedSearchSchemas: [],
    },
    getters: {
        defauleSearchSchema:(state)=>{
            return state.defauleSearchSchema;
        },
      
           // 保存的搜索方案
        savedSearchSchemas: (state) => {
            return state.savedSearchSchemas;
        },
        getSavedSearchSchema :(state,name) => {
               console.log(name)
                return function(key){
                let i = state.defauleSearchSchema.defaultFilter.findIndex( item => item.key && item.key === key );
                if(i === -1) {
                    return [];
                } else {
                    return state.defauleSearchSchema.defaultFilter[i]["buckets"];
                }
            }
            
        }
    },
    mutations: {
        
        // 设置保存搜索方案
        setSavedSearchSchemas(state, newValue) {
            if(Array.isArray(newValue)) {
                Vue.set(state, 'savedSearchSchemas', [...newValue]);
            }  
        },
        upsertSavedSearchSchema(state, newValue) {
   
            if(newValue && newValue.key) {
                let i = state.savedSearchSchemas.findIndex( item => item.key && item.key === newValue.key );
                if(i === -1) {
                    state.savedSearchSchemas.push(newValue);
                } else {
                    Vue.set(state.savedSearchSchemas, i,{...newValue} );  
                }
            }
        },
        updateDefaultSearchSchema(state,newValue) {
            if(newValue && newValue.key) {
                let i = state.defauleSearchSchema.defaultFilter.findIndex( item => item.key && item.key === newValue.key );
                if(i === -1) {
                    state.defauleSearchSchema.defaultFilter.push(newValue);
                } else {
                    Vue.set(state.defauleSearchSchema.defaultFilter, i,{...newValue} );  
                }
            }
        }
    },
    actions: {

        async analysisData({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.analyse, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async rationList({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.list, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async analySave({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.save, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async currentRation({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.ur, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async rationInfo({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.info, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async customSave({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.saveCustom, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async enterPriseAnalyse({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.analysis.portrait, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async saveCustomRation({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.customsave,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async queryCustomList({commit}, {data, handle}){
            try {
              
               //alert(data);
                commit('startLoading', null, {
                    root: true
                });
                 
                const rsp = await axios.get(ApiUrl.analysis.customList,data);
                let list = rsp.data.other
                console.log(list)
              if(list){
                list.forEach(element => {
                    element.key = element.first+'-'+element.second,
                    element.label = element.name
                    element.default = 'lineChart'
                });
                
            }
                let data = {
                    key: 'other',
                    label: '自定义分析',
                    buckets: list
                }
                
                commit('updateDefaultSearchSchema', data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async deleteSavedPro({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.analysis.delete,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async updateSavePro({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.analysis.update,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async updateSavedItem ({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.analysis.cusUpdate,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }
    }
}

